import { initializeApp } from "firebase/app";
import { 
    getAuth, 
    sendSignInLinkToEmail, 
    isSignInWithEmailLink, 
    signInWithEmailLink, 
    signOut, 
    GoogleAuthProvider, 
    signInWithPopup 
} from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyA238HejrZll7R3yjZZjH-fagQ_m7sEgpU",
    authDomain: "aivan-gag49.firebaseapp.com",
    projectId: "aivan-gag49",
    storageBucket: "aivan-gag49.firebasestorage.app",
    messagingSenderId: "789126936711",
    appId: "1:789126936711:web:aaa8bb509fcbd8f44f2022",
    measurementId: "G-HGEB31H05L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and Google Provider
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Export Auth, Provider, and Methods
export { 
    auth, 
    sendSignInLinkToEmail, 
    isSignInWithEmailLink, 
    signInWithEmailLink, 
    signOut, 
    googleProvider, 
    signInWithPopup 
};